document.addEventListener('DOMContentLoaded', function () {
  var section = document.querySelector('.diip-ps2');
  if (!section) return;

  /* ---------- Slideshow crossfade อัตโนมัติ ---------- */
  var slideshow = section.querySelector('[data-slideshow]');
  if (slideshow) {
    var slides = slideshow.querySelectorAll('.diip-ps2__slide');
    var dots = section.querySelectorAll('.diip-ps2__dot');
    var interval = parseInt(slideshow.getAttribute('data-autoplay'), 10) || 5;
    var current = 0;

    if (slides.length > 1) {
      setInterval(function () {
        slides[current].classList.remove('is-active');
        if (dots[current]) dots[current].classList.remove('is-active');
        current = (current + 1) % slides.length;
        slides[current].classList.add('is-active');
        if (dots[current]) dots[current].classList.add('is-active');
      }, interval * 1000);
    }
  }

  /* ---------- Add to Cart จริง ผ่าน Shopify Cart AJAX API + เปิด Cart Drawer ---------- */
  var addToCartBtn = section.querySelector('[data-add-to-cart]');
  var messageEl = document.getElementById('diip-ps2-cart-message');

  if (addToCartBtn) {
    var originalText = addToCartBtn.textContent;

    addToCartBtn.addEventListener('click', function () {
      var variantId = addToCartBtn.getAttribute('data-variant-id');
      if (!variantId) return;

      addToCartBtn.disabled = true;
      addToCartBtn.textContent = 'Adding...';
      if (messageEl) {
        messageEl.textContent = '';
        messageEl.className = 'diip-ps2__cart-message';
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }],
          sections: 'cart-drawer,cart-icon-bubble',
          sections_url: window.location.pathname,
        }),
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Add to cart failed');
          return response.json();
        })
        .then(function (data) {
          if (messageEl) {
            messageEl.textContent = 'Added to cart ✓';
            messageEl.className = 'diip-ps2__cart-message is-success';
          }

          var cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
            cartDrawer.renderContents(data);
          } else if (data.sections) {
            Object.keys(data.sections).forEach(function (sectionId) {
              var target = document.getElementById(sectionId);
              if (!target) return;
              var temp = document.createElement('div');
              temp.innerHTML = data.sections[sectionId];
              var replacement = temp.firstElementChild;
              if (replacement) target.replaceWith(replacement);
            });
            var cartIcon = document.getElementById('cart-icon-bubble');
            if (cartIcon) cartIcon.click();
          }
        })
        .catch(function () {
          if (messageEl) {
            messageEl.textContent = 'Failed to add. Please try again.';
            messageEl.className = 'diip-ps2__cart-message is-error';
          }
        })
        .finally(function () {
          addToCartBtn.disabled = false;
          addToCartBtn.textContent = originalText;
        });
    });
  }
});
